export default __webpack_public_path__ + "static/media/car.36c66f4b.jpg";